<h2 mat-dialog-title class="dialog-title">{{ dialogTitle }}</h2>

<form [formGroup]="addRowForm" class="p-3">
  <mat-form-field appearance="outline" class="col-4" *ngIf="isEditMode">
    <mat-label>Order No</mat-label>
    <input matInput formControlName="orderNo">
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Topic</mat-label>
    <input matInput formControlName="topic" #topicField>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Inductor By</mat-label>
    <mat-select formControlName="inductorBy" #inductorByField>
      <mat-option value="HR">HR</mat-option>
      <mat-option *ngFor="let e of counsellors$ | async" [value]="e.userName">
        {{ e.userName }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Date</mat-label>
    <input matInput [matDatepicker]="picker" formControlName="date" placeholder="Select date" #dateField>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-12">
    <mat-label>Sub Topic</mat-label>
    <textarea matInput formControlName="subTopic" #subTopicField></textarea>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-12">
    <mat-label>Description</mat-label>
    <textarea matInput formControlName="description" #descriptionField></textarea>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-12">
    <mat-label>Feedback</mat-label>
    <textarea matInput formControlName="feedback" #feedbackField></textarea>
  </mat-form-field>

  <div class="col-12 justify-content-center d-flex gap-2">
    <button mat-button mat-dialog-close color="warn">Cancel</button>
    <button mat-flat-button color="primary" (click)="submitRow()">
      <span>Save</span>
    </button>
  </div>
</form>
